export default (() => {  
  document.addEventListener('DOMContentLoaded', () => {

    // Mobile menu toggle
    const menuButton = document.getElementById('menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const closeMenuButton = document.getElementById('close-menu-button');
    const menuContent = document.getElementById('menu-content');
    const horizontalLinesContainer = document.getElementById('horizontal-lines');
    const verticalLinesContainer = document.getElementById('vertical-lines');
    const backgroundFill = document.getElementById('background-fill');
    
    // Logo animation elements
    const menuLogoSingle = document.querySelector('.menu-logo-single');
    const menuLogoClone = document.querySelector('.menu-logo-clone');
    
    // Function to calculate the optimal separation based on logo width
    function calculateLogoSeparation() {
      // Get the navbar logo container width
      const logoContainer = document.querySelector('.logo-animation-container');
      if (!logoContainer) return;
      
      // Calculate the width of the logo
      const logoWidth = logoContainer.offsetWidth;
      
      // Original logo has a width of 234px and the separation is 8px
      const separationRatio = 0.0242;
      const separationPercentage = separationRatio * 100;
      
      // Apply the separation percentage to the CSS variable
      document.documentElement.style.setProperty('--logo-separation', `${separationPercentage}%`);
    }
    
    // Number of lines for the weaving effect
    const numLines = 12;
    let animationInProgress = false;
    const animationDuration = 1500; // Total animation duration in ms
    const lineTransitionDuration = 400; // Duration for each line to grow in ms
    
    // Create the weaving lines (will be hidden initially)
    function createWeavingLines() {
      // Create horizontal lines
      for (let i = 0; i < numLines; i++) {
        const hLine = document.createElement('div');
        hLine.className = 'weaving-line horizontal-line';
        hLine.style.top = `${i * (100 / numLines)}%`;
        hLine.style.opacity = '0';
        hLine.style.transform = 'scaleX(0)';
        horizontalLinesContainer.appendChild(hLine);
      }
      
      // Create vertical lines
      for (let i = 0; i < numLines; i++) {
        const vLine = document.createElement('div');
        vLine.className = 'weaving-line vertical-line';
        vLine.style.left = `${i * (100 / numLines)}%`;
        vLine.style.opacity = '0';
        vLine.style.transform = 'scaleY(0)';
        verticalLinesContainer.appendChild(vLine);
      }
    }
    
    // Animate the weaving effect
    function animateWeaving(isOpening = true) {
      return new Promise(resolve => {
        if (animationInProgress) return;
        animationInProgress = true;
        
        const horizontalLines = horizontalLinesContainer.querySelectorAll('.horizontal-line');
        const verticalLines = verticalLinesContainer.querySelectorAll('.vertical-line');
        
        // Check if we're on the home page by checking if the navbar logo has the animation class
        const navbarLogoSingle = document.getElementById('navbar-logo-single');
        const isHomePage = navbarLogoSingle && navbarLogoSingle.classList.contains('logo-single');
        
        // Reset all lines and background
        [...horizontalLines, ...verticalLines].forEach(line => {
          line.style.opacity = isOpening ? '0' : '0.85';
          line.style.transition = 'none';
          line.style.transform = isOpening ? 
            (line.classList.contains('horizontal-line') ? 'scaleX(0)' : 'scaleY(0)') : 
            (line.classList.contains('horizontal-line') ? 'scaleX(1)' : 'scaleY(1)');
        });
        
        // Reset background fill
        backgroundFill.style.opacity = isOpening ? '0' : '1';
        
        // Force reflow
        horizontalLinesContainer.offsetHeight;
        
        // Set transition for all lines
        [...horizontalLines, ...verticalLines].forEach(line => {
          line.style.transition = `opacity 0.3s ease-in-out, transform ${lineTransitionDuration}ms ease-in-out`;
        });
        
        // Calculate delay between each line to fit within total animation time
        const delayBetweenLines = (animationDuration - lineTransitionDuration) / (numLines * 2);
        
        // Animate the lines in sequence
        let delay = 0;
        
        // Function to animate a single line
        const animateLine = (line, index, isHorizontal) => {
          setTimeout(() => {
            line.style.opacity = isOpening ? '0.85' : '0';
            line.style.transform = isOpening ? 
              (isHorizontal ? 'scaleX(1)' : 'scaleY(1)') : 
              (isHorizontal ? 'scaleX(0)' : 'scaleY(0)');
            
            // If this is the last line, show/hide the background and menu content
            if (isHorizontal && index === numLines - 1) {
              setTimeout(() => {
                // Show/hide the background fill
                backgroundFill.style.opacity = isOpening ? '1' : '0';
                
                // Show/hide menu content after background appears
                setTimeout(() => {
                  if (isOpening) {
                    menuContent.style.opacity = '1';
                    menuContent.style.transition = 'opacity 0.3s ease-in-out';
                  }
                  
                  setTimeout(() => {
                    animationInProgress = false;
                    resolve();
                  }, 300);
                }, 300);
              }, lineTransitionDuration);
            }
          }, delay);
          
          delay += delayBetweenLines;
        };
        
        // Determine animation order based on opening or closing
        if (isOpening) {
          // When opening: animate from top-right to bottom-left
          for (let i = 0; i < numLines; i++) {
            animateLine(horizontalLines[i], i, true);
            animateLine(verticalLines[i], i, false);
          }
        } else {
          // When closing: animate from bottom-left to top-right (reverse)
          for (let i = numLines - 1; i >= 0; i--) {
            animateLine(horizontalLines[i], i, true);
            animateLine(verticalLines[i], i, false);
          }
        }
      });
    }
    
    // Function to animate the logo (separate or combine)
    function animateLogo(logoSingle, logoClone, separate = true) {
      console.log('Animating logo:', separate ? 'separating' : 'combining');
      if (!logoSingle || !logoClone) {
        console.log('Logo elements not found');
        return;
      }
      
      console.log('Logo elements found, applying animation');
      
      // Reset animations
      logoSingle.style.animation = 'none';
      logoClone.style.animation = 'none';
      logoSingle.offsetHeight; // Force reflow
      
      if (separate) {
        // Animate to separated state
        console.log('Applying separation animation');
        logoSingle.style.animation = 'logoSingleAnimation 1.5s ease-out forwards';
        logoClone.style.animation = 'logoCloneAnimation 1.5s ease-out forwards';
      } else {
        // Animate back to combined state
        console.log('Applying combination animation');
        logoSingle.style.animation = 'logoSingleReverseAnimation 1.5s ease-out forwards';
        logoClone.style.animation = 'logoCloneReverseAnimation 1.5s ease-out forwards';
      }
    }
    
    // Function to handle the logo animation loop
    function startLogoAnimationLoop() {
      console.log('Starting logo animation loop');
      const navbarLogoSingle = document.getElementById('navbar-logo-single');
      const navbarLogoClone = document.getElementById('navbar-logo-clone');
      
      // Check if we're on the home page by checking if the logo has the animation class
      const isHomePage = navbarLogoSingle.classList.contains('logo-single');
      
      if (!isHomePage) {
        console.log('Not on home page, skipping logo animation');
        return;
      }
      
      console.log('Logo elements:', navbarLogoSingle, navbarLogoClone);
      
      // Let the initial CSS animation play out, then start our loop
      setTimeout(() => {
        console.log('Setting up animation interval');
        
        setInterval(() => {
          console.log('Interval fired - combining logos');
          // Combine logos
          animateLogo(navbarLogoSingle, navbarLogoClone, false);
          
          // Wait 2 seconds, then separate again
          setTimeout(() => {
            console.log('Separation timeout fired');
            animateLogo(navbarLogoSingle, navbarLogoClone, true);
          }, 2000);
        }, 30000); // Loop every minute
      }, 10000); // Wait for initial animation to complete (3s delay + 1.5s animation + buffer)
    }
    
    // Initialize the menu
    if (menuButton && mobileMenu && closeMenuButton) {
      // Create the weaving lines
      createWeavingLines();
      
      // Open menu with animation
      menuButton.addEventListener('click', async () => {
        mobileMenu.classList.remove('hidden');
        document.body.classList.add('overflow-hidden');
        menuContent.style.opacity = '0'; // Hide content initially
        
        // Reset menu logo animation - use the original CSS animation
        if (menuLogoSingle && menuLogoClone) {
          menuLogoSingle.style.animation = 'none';
          menuLogoClone.style.animation = 'none';
          menuLogoSingle.offsetHeight; // Force reflow
          menuLogoSingle.style.animation = 'logoSingleAnimation 1.5s ease-out forwards';
          menuLogoSingle.style.animationDelay = '0.5s';
          menuLogoClone.style.animation = 'logoCloneAnimation 1.5s ease-out forwards';
          menuLogoClone.style.animationDelay = '0.5s';
        }
        
        // Start the weaving animation
        await animateWeaving(true);
      });
      
      // Close menu with reverse animation
      closeMenuButton.addEventListener('click', async () => {
        // Hide the menu content first
        menuContent.style.opacity = '0';
        menuContent.style.transition = 'opacity 0.2s ease-in-out';
        
        // Wait a bit before starting the reverse animation
        setTimeout(async () => {
          await animateWeaving(false);
          
          // Hide the menu after animation completes
          mobileMenu.classList.add('hidden');
          document.body.classList.remove('overflow-hidden');
        }, 200);
      });
    }
    
    // Handle initial page load logo animation
    window.addEventListener('load', () => {
      const navbarLogoSingle = document.getElementById('navbar-logo-single');
      const navbarLogoClone = document.getElementById('navbar-logo-clone');
      
      if (navbarLogoSingle && navbarLogoClone) {
        // The animation is handled by CSS with delays, but we can ensure it's properly initialized
        navbarLogoSingle.style.opacity = '1';
        navbarLogoClone.style.opacity = '0';
        
        // Start the logo animation loop
        startLogoAnimationLoop();
      }
      
      // Calculate and set the optimal logo separation
      calculateLogoSeparation();
    });
    
    // Recalculate on resize
    window.addEventListener('resize', calculateLogoSeparation);
  });
  
  return {}; // Return an empty object as this is an IIFE
})();